import "./styles.css";
import { createApp } from "./ui/app";

createApp(document.querySelector<HTMLDivElement>("#app"));
